import type { ReactNode } from 'react';
import './MapHudButton.css';

export type MapHudButtonProps = {
  className: string;
  ariaLabel: string;
  onClick?: () => void;
  children: ReactNode;
};

/** Shared map HUD plaque-button chrome (hover/active/focus). */
export function MapHudButton({
  className,
  ariaLabel,
  onClick,
  children,
}: MapHudButtonProps) {
  return (
    <button
      type="button"
      className={['map-hud-button', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
